module.exports = __webpack_public_path__ + "static/media/TradingFloor.a8db9845.png";